export const LocaleMap = {
  en: 'en_US',
  en_US: 'en_US',
  en_GB: 'en_GB',
  en_AU: 'en_AU',
  fr: 'fr_CA',
  fr_CA: 'fr_CA',
  es: 'es_ES',
  es_ES: 'es_ES',
  da: 'da_DK',
  da_DK: 'da_DK',
  de: 'de_DE',
  de_DE: 'de_DE',
  nl: 'nl_NL',
  nl_NL: 'nl_NL',
  fi: 'fi_FI',
  fi_FI: 'fi_FI',
  sv: 'sv_SE',
  sv_SE: 'sv_SE',
  hi: 'hi_IN',
  hi_IN: 'hi_IN',
  ja: 'ja_JP',
  ja_JP: 'ja_JP',
  id: 'id_ID',
  id_ID: 'id_ID',
};

export const Locales = {
  EN: 'en',
  EN_US: 'en_US',
  EN_GB: 'en_GB',
  EN_AU: 'en_AU',
  FR: 'fr',
  FR_CA: 'fr_CA',
  ES: 'es',
  ES_ES: 'es_ES',
  DA: 'da',
  DA_DK: 'da_DK',
  DE: 'de',
  DE_DE: 'de_DE',
  NL: 'nl',
  NL_NL: 'nl_NL',
  FI: 'fi',
  FI_FI: 'fi_FI',
  SV: 'sv',
  SV_SE: 'sv_SE',
  HI: 'hi',
  HI_IN: 'hi_IN',
  JA: 'ja',
  JA_JP: 'ja_JP',
  ID: 'id',
  ID_ID: 'id_ID',
  TEST: 'TEST',
};

export const CACHE_ID = 'tapclicks-i18n';
